// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".md-field[data-v-8494265a]{border-radius:5px}.active-icon[data-v-8494265a]{border:1px solid #19bdc0;border-radius:50%;color:#19bdc0!important;margin-bottom:1em;padding:1em}.buttons .md-button[data-v-8494265a]{font-size:.8vw!important}@media screen and (max-width:767px){.buttons .md-button[data-v-8494265a]{font-size:3vw!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
